/* GLADIATOR HOOPS — explore grid controller
   Pairs with sections/hoop-explore-grid.liquid.

   The deep-dive sections stay exactly where Shopify put them; they are
   hidden by an inline rule the section emits (so there is no flash of a
   3,000px page before this file runs) and revealed one at a time. Because
   every other collapsible sibling is display:none, whichever one is open
   always renders directly under the grid, whatever its order in the theme
   editor. Nothing is re-parented — two of these sections resolve their own
   script by DOM position and would silently break if moved. */
(function () {
  'use strict';

  var SVG = 'http://www.w3.org/2000/svg';

  function icon(d, extra) {
    var s = document.createElementNS(SVG, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2.2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    if (extra) s.setAttribute('class', extra);
    var p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  }

  var ARROW_L = 'M19 12H5M11 18l-6-6 6-6';
  var ARROW_R = 'M5 12h14M13 6l6 6-6 6';

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerOffset() {
    var h = document.querySelector('.gh-header');
    return (h ? Math.round(h.getBoundingClientRect().height) : 0) + 12;
  }

  function scrollToEl(el, extra) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - (extra || 0);
    if (top < 0) top = 0;
    try {
      window.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, top);
    }
  }

  function build(root) {
    var grid = root.querySelector('[data-ghx-grid]');
    if (!grid) return;

    /* JSON templates namespace section ids as template--123__key; the
       section hands us that prefix, and a bare key still resolves. */
    var prefix = root.getAttribute('data-ghx-prefix') || '';

    var items = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-ghx-tile]'), function (tile) {
      var key = tile.getAttribute('data-ghx-target');
      if (!key) { tile.setAttribute('hidden', ''); return; }
      var domId = 'shopify-section-' + prefix + key;
      var panel = document.getElementById(domId);
      if (!panel && prefix) {
        domId = 'shopify-section-' + key;
        panel = document.getElementById(domId);
      }
      if (!panel) { tile.setAttribute('hidden', ''); return; }
      panel.classList.add('ghx-panel');
      tile.setAttribute('aria-controls', domId);
      tile.setAttribute('aria-expanded', 'false');
      items.push({
        key: key,
        domId: domId,
        tile: tile,
        panel: panel,
        title: (tile.getAttribute('data-ghx-title') || key).trim()
      });
    });
    if (!items.length) return;

    /* ---------- chrome that travels with the open panel ---------- */
    var crumb = document.createElement('div');
    crumb.className = 'ghx-crumb';
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'ghx-crumb__back';
    back.appendChild(icon(ARROW_L));
    back.appendChild(document.createTextNode('All topics'));
    var crumbTitle = document.createElement('span');
    crumbTitle.className = 'ghx-crumb__title';
    var live = document.createElement('span');
    live.className = 'ghx-sr';
    live.setAttribute('aria-live', 'polite');
    var rule = document.createElement('span');
    rule.className = 'ghx-crumb__rule';
    crumb.appendChild(back);
    crumb.appendChild(crumbTitle);
    crumb.appendChild(rule);
    crumb.appendChild(live);

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function navBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ghx-navbar__btn ghx-navbar__btn--' + dir;
      var lbl = document.createElement('span');
      lbl.className = 'ghx-navbar__lbl';
      var k = document.createElement('span');
      k.className = 'ghx-navbar__kicker';
      k.textContent = dir === 'prev' ? 'Previous' : 'Next';
      var n = document.createElement('span');
      n.className = 'ghx-navbar__name';
      lbl.appendChild(k);
      lbl.appendChild(n);
      if (dir === 'prev') { b.appendChild(icon(ARROW_L)); b.appendChild(lbl); }
      else { b.appendChild(lbl); b.appendChild(icon(ARROW_R)); }
      b._name = n;
      return b;
    }

    var navbar = document.createElement('div');
    navbar.className = 'ghx-navbar';
    var prevBtn = navBtn('prev');
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ghx-navbar__close';
    closeBtn.textContent = 'Close topic';
    var nextBtn = navBtn('next');
    navbar.appendChild(prevBtn);
    navbar.appendChild(closeBtn);
    navbar.appendChild(nextBtn);

    var hint = root.querySelector('[data-ghx-hint]');
    var hintOpen = root.getAttribute('data-ghx-hint-open') || 'Pick another topic';
    var hintShut = hint ? hint.innerHTML : '';

    var cur = -1;

    function detach(el) { if (el.parentNode) el.parentNode.removeChild(el); }

    function open(i, opts) {
      opts = opts || {};
      if (i < 0 || i >= items.length) return;
      if (cur === i && !opts.force) { close(true); return; }

      items.forEach(function (it, n) {
        var on = n === i;
        it.panel.classList.toggle('ghx-open', on);
        it.tile.classList.toggle('is-active', on);
        it.tile.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      var it = items[i];
      cur = i;
      root.classList.add('is-active');
      if (hint) hint.textContent = hintOpen;

      crumbTitle.textContent = pad(i + 1) + ' / ' + pad(items.length);
      live.textContent = 'Opened: ' + it.title;
      it.panel.insertBefore(crumb, it.panel.firstChild);
      it.panel.appendChild(navbar);
      var p = items[(i - 1 + items.length) % items.length];
      var n = items[(i + 1) % items.length];
      prevBtn._name.textContent = p.title;
      nextBtn._name.textContent = n.title;

      /* anything that sizes itself off clientWidth was measuring a hidden
         box until a moment ago — give it a reason to re-measure */
      try { window.dispatchEvent(new Event('resize')); } catch (err) {}

      try { history.replaceState(null, '', '#t-' + it.key); } catch (err) {}

      /* centre the active pill in the rail without touching page scroll */
      if (grid.scrollWidth > grid.clientWidth + 2) {
        var left = (it.tile.offsetLeft - grid.offsetLeft) - (grid.clientWidth - it.tile.offsetWidth) / 2;
        if (left < 0) left = 0;
        try { grid.scrollTo({ left: left, behavior: reduced() ? 'auto' : 'smooth' }); }
        catch (err) { grid.scrollLeft = left; }
      }

      /* land on the rail, not the panel: in rail mode this section is only
         the strip of topic pills, so the open topic starts right below it
         and switching topics never means scrolling back up */
      if (!opts.silent) {
        if (reduced()) { scrollToEl(root); }
        else { requestAnimationFrame(function () { scrollToEl(root); }); }
      }
      if (opts.focus !== false) {
        it.panel.setAttribute('tabindex', '-1');
        try { it.panel.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    function close(toGrid) {
      if (cur < 0) return;
      var it = items[cur];
      it.panel.classList.remove('ghx-open');
      it.tile.classList.remove('is-active');
      it.tile.setAttribute('aria-expanded', 'false');
      detach(crumb);
      detach(navbar);
      cur = -1;
      root.classList.remove('is-active');
      if (hint) hint.innerHTML = hintShut;
      try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (err) {}
      if (toGrid) {
        scrollToEl(root, 10);
        try { it.tile.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    items.forEach(function (it, i) {
      it.tile.addEventListener('click', function () { open(i); });
    });
    back.addEventListener('click', function () { close(true); });
    closeBtn.addEventListener('click', function () { close(true); });
    prevBtn.addEventListener('click', function () { open((cur - 1 + items.length) % items.length, { force: true }); });
    nextBtn.addEventListener('click', function () { open((cur + 1) % items.length, { force: true }); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cur > -1) { close(true); }
    });

    /* ---------- resolving a link or a hash to a topic ---------- */
    function indexForHash(raw) {
      if (!raw) return -1;
      var id = raw.replace(/^#/, '');
      if (!id) return -1;
      var i;
      for (i = 0; i < items.length; i++) {
        if (id === 't-' + items[i].key || id === items[i].key ||
            id === items[i].domId) return i;
      }
      var el = null;
      try { el = document.getElementById(id); } catch (err) { return -1; }
      if (!el) return -1;
      for (i = 0; i < items.length; i++) {
        if (items[i].panel.contains(el)) return i;
      }
      return -1;
    }

    /* a link anywhere on the page that points into a collapsed topic
       should open it rather than scroll to nothing */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a || a.getAttribute('target') === '_blank') return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;
      var idx = indexForHash(url.hash);
      if (idx < 0) return;
      e.preventDefault();
      open(idx, { force: true });
    });

    var initial = indexForHash(window.location.hash);
    if (initial > -1) {
      open(initial, { force: true, silent: true, focus: false });
      /* the page keeps growing after the jump as images and the 3D viewer
         resolve, so re-settle a few times — and stop the moment the visitor
         takes over, same contract as gh-anchor.js */
      var cancelled = false;
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (evt) {
        window.addEventListener(evt, function () { cancelled = true; }, { passive: true, once: true });
      });
      var jump = function () { if (!cancelled) scrollToEl(root); };
      jump();
      window.addEventListener('load', function () {
        [120, 600, 1400].forEach(function (ms) { setTimeout(jump, ms); });
      });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ghx-root]'), build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
